<template>
    <!-- dialog选择分类开始 -->
    <el-dialog
            wvalueth="835px"
            :title="title"
            class="class-list-dialog big_box"
            :modal="false"
            @close="close()"
            :close-on-click-modal="false"
            :visible.sync="handle">
        <div class="class-list clearfix">
            <template>
                <div class="checkbox-table" v-for="(item, indexkey) in menu" :key="item.value">
                    <template>
                        <!--一级-->
                        <p ><el-radio  @change="handleCheck(item.value,item.label)" v-model="checkeds" :label="item.value" style="font-weight: bold;color: #23B2E4;font-size: 25px;">{{item.label}}</el-radio></p>
                        <div style="margin-top: 5px;margin-bottom: 5px;"></div>
                        <el-popover
                                :key="list.value"
                                v-for="list in item.children"
                                placement="top"
                                width="150"
                                trigger="hover">
                            <!--三级分类-->
                            <el-radio-group v-model="checkeds">
                                <el-radio
                                        v-for="list_3 in list.children" :key="list_3.value"
                                        :label="list_3.value"
                                        @change="handleCheck(list_3.value,list_3.label)" style="margin: 0 0 5px 0">
                                    {{list_3.label}}
                                </el-radio>
                            </el-radio-group>
                            <span slot="reference" style="border-radius: 30px">
                                <el-radio  @change="handleCheck(list.value,list.label)" v-model="checkeds" :label="list.value" style="margin: 5px 30px 5px 0">{{list.label}}</el-radio>
                            </span>
                        </el-popover>
                        <hr>
                    </template>
                </div>
            </template>
        </div>
        <div slot="footer">
            <el-button size="mini" @click="close()" title="取消">取 消</el-button>
            <el-button size="mini" type="primary" @click="handleConfirm()" title="确定">确 定</el-button>
        </div>
    </el-dialog>
    <!-- dialog选择分类结束 -->
</template>
<style>
</style>
<script>
    export default {
        props: {
            handle: {
                type: Boolean,
                default: false
            },
        },
        watch: {
            handle: function (data, old) {
                this.handle = data;
            },
        },
        created: function () {
        },
        mounted: function () {
            let state = localStorage.getItem("category");
            if(state !== null){
                this.state = JSON.parse(state)
                this.checkeds=this.state.last_value
                this.title = this.title+' -- 历史选择：'+this.state.last_label
            }
            this.initData();
        },
        computed: {},
        data() {
            return {
                menu: [], //所有的菜单数组
                checkeds: null, //已选的菜单id
                state: {last_value: 0, last_label: ''},
                last_value: 0,
                last_label: "",
                title:'选择分类'
            }
        },
        methods: {
            // start:
            initData() {
                let that = this
                this.$ajax
                    .post("common/find/category_cascade", {})
                    .then(function (res) {
                        if (res.data.error === 0) {
                            that.menu = res.data.data;
                        }
                    })
                    .catch(function (err) {
                        that.$message("网络错误！请联系管理员");
                        that.loading = false;
                    });
            },
            // 处理选择事件
            handleCheck(value, label) { // 多选框
                if (this.state.last_value !== value) {
                    this.checked = value;
                    this.state.last_value = value;
                    this.state.last_label = label;
                } else {
                    this.state.last_value = 0;
                    this.state.last_label = '';
                }

            },
            handleConfirm() {
                let that = this
                if (that.state.last_value > 0) {
                    localStorage.setItem("category", JSON.stringify(that.state));
                    that.$emit('confirm', that.state)
                } else {
                    that.$message('没有选任何分类')
                }
            },
            close() {
                this.$emit('closeSelf', false)
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/dialog/Category.vue